import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {RootState} from '../interfaces'

import additionalOption from './additionalOption'
import admissionDetail from './admission'
import aitems from './aitems'
import banner from './banner'
import card from './card'
import chargePoint from './chargePoint'
import common from './common'
import deliveryInfo from './deliveryInfo'
import deliveryManager from './deliveryManager'
import error from './error'
import orderTotal from './orderTotal'
import personalCustomsClearance from './personalCustomsClearance'
import pickup from './pickup'
import pointPayment from './pointPayment'
import productDetail from './productDetail'
import purchaser from './purchaser'
import recommendationProduct from './recommendationProduct'
import reward from './reward'
import rewardPoint from './rewardPoint'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        additionalOption,
        admissionDetail,
        aitems,
        banner,
        card,
        chargePoint,
        common,
        deliveryInfo,
        deliveryManager,
        error,
        orderTotal,
        pickup,
        pointPayment,
        personalCustomsClearance,
        productDetail,
        purchaser,
        recommendationProduct,
        reward,
        rewardPoint,
        router: routerReducer,
    })

export default createRootReducer
